export default __webpack_public_path__ + "static/media/master-configurations.e7bb3d69.svg";